import React from 'react';
import PropTypes from 'prop-types';
import Icon from 'common/icon/Icon';
import TabbedSearchControls from 'search/controls/TabbedSearchControls';

const VALUE_PROPS = [
    'Fast Prepay',
    'Mobile Parking Pass',
    'Easy Cancellation'
];

const HomeHero = ({initialValue}) => (
    <div className="HomeHero">
        <div className="HomeHero-content">
            <header className="HomeHero-header">
                <div className="HomeHero-icon">
                    <Icon name="hero-car" />
                </div>
                <h1>Let&apos;s Find Your Spot</h1>
            </header>
            <TabbedSearchControls
                initialValue={initialValue}
            />
        </div>
        <footer className="HomeHero-values">
            <ul>
                {
                    VALUE_PROPS.map(value => (
                        <li
                            className="HomeHero-value"
                            key={value}
                        >
                            <span>{value}</span>
                        </li>
                    ))
                }
            </ul>
        </footer>
    </div>
);

HomeHero.propTypes = {
    initialValue: PropTypes.string,
};

export default HomeHero;
